#import "./UserRankFields.graphql"

mutation UserRankUpdate($input: UserRankUpdateInput!) {
  userRankUpdate(input: $input) {
    userRankType {
      ...UserRankFields
    }
  }
}
